import React, { Component } from 'react'
import motorRoutes from '../../routes/motor'
import { Route, Switch, Redirect } from 'react-router'
import withStyles from '@material-ui/core/styles/withStyles'
import { connect } from 'react-redux'
import appStyle from './style'
import CssBaseline from '@material-ui/core/CssBaseline'
import './style.css'
import _ from 'lodash'

class MotorLayout extends Component {
  render() {
    const { callbackVersion, currentProduct } = this.props
    return (
      <div>
        <CssBaseline />
        <Switch>
          {motorRoutes.map((prop, key) => {
            if (prop.redirect) {
              let thisFrom = prop.path
              let thisTo = prop.pathTo
              if (thisFrom === '/' && thisTo === '/home') {
                if (callbackVersion === 2) {
                  if (currentProduct === 'V') {
                    thisTo = '/select-car-model'
                  } else if (currentProduct === 'C') {
                    thisTo = '/select-package'
                  }
                }
              }
              return <Redirect from={thisFrom} to={thisTo} key={key} />
            }
            return (
              <Route
                key={key}
                path={prop.path}
                component={prop.component}
                exact
              />
            )
          })}
        </Switch>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    callbackVersion: _.get(state, 'motor.userInput.callbackVersion', 1),
    currentProduct: _.get(state, 'motor.userInput.currentProduct', ''),
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(appStyle)(MotorLayout))
